// 常量转换
export const enumValueByKey = (value, obj) => {
  let tag = ''
  obj.forEach(item => {
    if (item.value === value) tag = item.desc
  })
  return tag
}
